// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from './gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { AutofillDataFragmentDoc } from './common-queries.generated';
export type AnnotationItemFragment = {
  readonly __typename: 'Annotation';
  readonly fid: string;
  readonly dateTime: string;
  readonly text: string;
  readonly agentInfo: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly structuredName: {
      readonly __typename: 'Name';
      readonly full: string;
      readonly first: string | null;
    };
  } | null;
};

export type ReceiptItemFragment = {
  readonly __typename: 'Receipt';
  readonly fid: string;
  readonly mime: string;
  readonly uploadedAt: string;
  readonly userData: string | null;
  readonly isInvoice: boolean;
  readonly receiptLooksValid: boolean;
  readonly images: {
    readonly __typename: 'ReceiptImages';
    readonly color: string;
    readonly originalUrl: string;
    readonly croppedUrl: string | null;
    readonly thumbnail128Url: string | null;
    readonly thumbnail256Url: string | null;
    readonly thumbnail512Url: string | null;
  };
};

export type LedgerCategoryInfoItemFragment = {
  readonly __typename: 'LedgerCategoryInfo';
  readonly kind: Types.LedgerCategoryInfoKind;
  readonly category: {
    readonly __typename: 'LedgerCategoryItem';
    readonly fid: string;
    readonly title: string;
    readonly subtitle: string | null;
    readonly icon: Types.LedgerCategoryIcon;
    readonly synonyms: ReadonlyArray<string>;
    readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
  } | null;
  readonly guesses: ReadonlyArray<{
    readonly __typename: 'LedgerCategoryItem';
    readonly fid: string;
  }>;
};

export type InvoiceItemFragment = {
  readonly __typename: 'Invoice';
  readonly fid: string;
  readonly mime: string;
  readonly filename: string | null;
  readonly createdAt: string;
  readonly images: {
    readonly __typename: 'ReceiptImages';
    readonly color: string;
    readonly originalUrl: string;
    readonly croppedUrl: string | null;
    readonly thumbnail128Url: string | null;
    readonly thumbnail256Url: string | null;
    readonly thumbnail512Url: string | null;
  };
};

export type EventItemFragment = {
  readonly __typename: 'Event';
  readonly fid: string;
  readonly dateTime: string;
  readonly movementType: Types.MovementType;
  readonly title: string;
  readonly description: string;
  readonly subtitle: string | null;
  readonly infoLine: string | null;
  readonly icon: string | null;
  readonly bulkPaymentFid: string | null;
  readonly currencyAmount: string | null;
  readonly currencyCode: string | null;
  readonly amount: string | null;
  readonly physicalTerminal: boolean;
  readonly isInvoice: boolean;
  readonly isOwnCardEvent: boolean;
  readonly completed: boolean;
  readonly isEditable: boolean;
  readonly card: {
    readonly __typename: 'Card';
    readonly fid: string;
    readonly name: string | null;
  } | null;
  readonly account: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly name: string;
  } | null;
  readonly transaction: {
    readonly __typename: 'EventTransaction';
    readonly fid: string;
    readonly remittanceInformation: string | null;
    readonly debtorAccountNumber: string | null;
    readonly creditorAccountNumber: string | null;
    readonly kid: string | null;
    readonly bookingDate: string | null;
    readonly isPending: boolean;
  } | null;
  readonly payment: {
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly status: Types.PaymentStatus;
    readonly kid: string | null;
    readonly message: string | null;
    readonly debtorAccount: string;
    readonly creditorAccount: string;
    readonly isTaxPayment: boolean;
    readonly external: boolean;
    readonly fee: string | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly ledgerAccount: number | null;
      readonly externalURL: string | null;
    } | null;
  } | null;
  readonly merchant: {
    readonly __typename: 'Merchant';
    readonly fid: string;
    readonly name: string;
  } | null;
  readonly receipts: ReadonlyArray<{
    readonly __typename: 'Receipt';
    readonly fid: string;
    readonly mime: string;
    readonly uploadedAt: string;
    readonly userData: string | null;
    readonly isInvoice: boolean;
    readonly receiptLooksValid: boolean;
    readonly images: {
      readonly __typename: 'ReceiptImages';
      readonly color: string;
      readonly originalUrl: string;
      readonly croppedUrl: string | null;
      readonly thumbnail128Url: string | null;
      readonly thumbnail256Url: string | null;
      readonly thumbnail512Url: string | null;
    };
  }>;
  readonly note: {
    readonly __typename: 'Annotation';
    readonly fid: string;
    readonly dateTime: string;
    readonly text: string;
    readonly agentInfo: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
  } | null;
  readonly purpose: {
    readonly __typename: 'Annotation';
    readonly fid: string;
    readonly dateTime: string;
    readonly text: string;
    readonly agentInfo: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
  } | null;
  readonly participants: {
    readonly __typename: 'Annotation';
    readonly fid: string;
    readonly dateTime: string;
    readonly text: string;
    readonly agentInfo: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
  } | null;
  readonly receiptNotNeeded: {
    readonly __typename: 'Annotation';
    readonly fid: string;
    readonly dateTime: string;
    readonly text: string;
    readonly agentInfo: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
  } | null;
  readonly receiptLost: {
    readonly __typename: 'Annotation';
    readonly fid: string;
    readonly dateTime: string;
    readonly text: string;
    readonly agentInfo: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
  } | null;
  readonly requirements: {
    readonly __typename: 'EventRequirements';
    readonly metRequirementCount: number;
    readonly totalRequirementCount: number;
    readonly allRequirementsMet: boolean;
    readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
    readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
    readonly requirementsOverridden: {
      readonly __typename: 'RequirementsOverriddenInfo';
      readonly overridden: boolean;
      readonly accountingSystem: string | null;
    };
  };
  readonly ledgerCategoryInfo: {
    readonly __typename: 'LedgerCategoryInfo';
    readonly kind: Types.LedgerCategoryInfoKind;
    readonly category: {
      readonly __typename: 'LedgerCategoryItem';
      readonly fid: string;
      readonly title: string;
      readonly subtitle: string | null;
      readonly icon: Types.LedgerCategoryIcon;
      readonly synonyms: ReadonlyArray<string>;
      readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
    } | null;
    readonly guesses: ReadonlyArray<{
      readonly __typename: 'LedgerCategoryItem';
      readonly fid: string;
    }>;
  };
};

export type DismissAgentHintMutationVariables = Types.Exact<{
  agentHintKind: Types.AgentHintKind;
}>;

export type DismissAgentHintMutation = {
  readonly __typename: 'Mutation';
  readonly dismissAgentHint: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly activeHints: ReadonlyArray<{
      readonly __typename: 'AgentHint';
      readonly kind: Types.AgentHintKind;
      readonly dismissable: boolean;
      readonly targets: ReadonlyArray<Types.Target>;
    }>;
  };
};

export type LookupCardPinQueryVariables = Types.Exact<{
  cardFid: Types.Scalars['ID'];
  encryptedData: Types.Scalars['String'];
}>;

export type LookupCardPinQuery = {
  readonly __typename: 'Query';
  readonly lookupCardPin: string;
};

export type ActivateCardMutationVariables = Types.Exact<{
  cardFid: Types.Scalars['ID'];
}>;

export type ActivateCardMutation = {
  readonly __typename: 'Mutation';
  readonly activateCard: ReadonlyArray<{
    readonly __typename: 'Card';
    readonly fid: string;
    readonly state: Types.CardState;
  }>;
};

export type BlockCardMutationVariables = Types.Exact<{
  cardFid: Types.Scalars['ID'];
}>;

export type BlockCardMutation = {
  readonly __typename: 'Mutation';
  readonly blockCard: {
    readonly __typename: 'Card';
    readonly fid: string;
    readonly state: Types.CardState;
  };
};

export type UnblockCardMutationVariables = Types.Exact<{
  cardFid: Types.Scalars['ID'];
}>;

export type UnblockCardMutation = {
  readonly __typename: 'Mutation';
  readonly unblockCard: {
    readonly __typename: 'Card';
    readonly fid: string;
    readonly state: Types.CardState;
  };
};

export type StartAutofillMutationVariables = Types.Exact<{
  accountNumber: Types.Scalars['AccountNumber'];
  desiredAmount: Types.Scalars['Amount'];
  lowLimit: Types.Scalars['Amount'];
  dailyLimit: Types.Scalars['Amount'];
}>;

export type StartAutofillMutation = {
  readonly __typename: 'Mutation';
  readonly startAutofill: {
    readonly __typename: 'StartAutofillReply';
    readonly cardAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly autofill: {
        readonly __typename: 'Autofill';
        readonly desiredAmount: string;
        readonly lowLimit: string;
        readonly dailyLimit: string;
        readonly isDailyLimitReached: boolean;
      } | null;
    };
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
  };
};

export type StopAutofillMutationVariables = Types.Exact<{
  accountNumber: Types.Scalars['AccountNumber'];
}>;

export type StopAutofillMutation = {
  readonly __typename: 'Mutation';
  readonly stopAutofill: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly autofill: {
      readonly __typename: 'Autofill';
      readonly desiredAmount: string;
      readonly lowLimit: string;
      readonly dailyLimit: string;
      readonly isDailyLimitReached: boolean;
    } | null;
  };
};

export type SetAgentEmailAndPhoneMutationVariables = Types.Exact<{
  email: Types.Scalars['Email'];
  mobileNumber: Types.Scalars['String'];
  updateAllAgents: Types.Scalars['Boolean'];
}>;

export type SetAgentEmailAndPhoneMutation = {
  readonly __typename: 'Mutation';
  readonly setAgentEmailAndPhone: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly intercomEmail: string | null;
    readonly email: string | null;
    readonly mobileNumber: string | null;
  };
};

export type AllAgentEmailsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type AllAgentEmailsQuery = {
  readonly __typename: 'Query';
  readonly me: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly email: string | null;
    readonly agents: ReadonlyArray<{
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly email: string | null;
    }>;
  };
};

export type SetUserAvatarMutationVariables = Types.Exact<{
  avatar: Types.AvatarId;
}>;

export type SetUserAvatarMutation = {
  readonly __typename: 'Mutation';
  readonly setUserAvatar: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly avatarId: Types.AvatarId;
  };
};

export const InvoiceItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvoiceItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Invoice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'croppedUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail128Url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail256Url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail512Url' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceItemFragment, unknown>;
export const ReceiptItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReceiptItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Receipt' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'croppedUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail128Url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail256Url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail512Url' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInvoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptLooksValid' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReceiptItemFragment, unknown>;
export const AnnotationItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnnotationItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Annotation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'structuredName' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnnotationItemFragment, unknown>;
export const LedgerCategoryInfoItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LedgerCategoryInfoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LedgerCategoryInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'synonyms' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requirements' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guesses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LedgerCategoryInfoItemFragment, unknown>;
export const EventItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Event' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'movementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'infoLine' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'card' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transaction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remittanceInformation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'debtorAccountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditorAccountNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'kid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPending' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'paymentFid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'debtorAccount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditorAccount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTaxPayment' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'external' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fee' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'structuredName' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'full' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'signedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'structuredName' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'full' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ledgerAccount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalURL' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bulkPaymentFid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'merchant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalTerminal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInvoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOwnCardEvent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receipts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReceiptItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'note' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AnnotationItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purpose' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AnnotationItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AnnotationItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receiptNotNeeded' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AnnotationItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receiptLost' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AnnotationItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requirements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metRequirementCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRequirementCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allRequirementsMet' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allRequirements' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unmetRequirements' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requirementsOverridden' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overridden' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountingSystem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerCategoryInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LedgerCategoryInfoItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isEditable' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventItemFragment, unknown>;
export const DismissAgentHintDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissAgentHint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'agentHintKind' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AgentHintKind' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissAgentHint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hint' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'agentHintKind' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'targets' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DismissAgentHintMutation,
  DismissAgentHintMutationVariables
>;
export const LookupCardPinDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LookupCardPin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cardFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'encryptedData' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lookupCardPin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cardFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cardFid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'encryptedCardData' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'encryptedData' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LookupCardPinQuery, LookupCardPinQueryVariables>;
export const ActivateCardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cardFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cardFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cardFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivateCardMutation,
  ActivateCardMutationVariables
>;
export const BlockCardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BlockCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cardFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blockCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cardFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cardFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockCardMutation, BlockCardMutationVariables>;
export const UnblockCardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnblockCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cardFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unblockCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cardFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cardFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnblockCardMutation, UnblockCardMutationVariables>;
export const StartAutofillDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartAutofill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountNumber' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'desiredAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lowLimit' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dailyLimit' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startAutofill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'desiredAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'desiredAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lowLimit' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lowLimit' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dailyLimit' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dailyLimit' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutofillData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operationalAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balanceNok' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AutofillDataFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  StartAutofillMutation,
  StartAutofillMutationVariables
>;
export const StopAutofillDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StopAutofill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountNumber' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopAutofill' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutofillData' },
                },
              ],
            },
          },
        ],
      },
    },
    ...AutofillDataFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  StopAutofillMutation,
  StopAutofillMutationVariables
>;
export const SetAgentEmailAndPhoneDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAgentEmailAndPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Email' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'mobileNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'updateAllAgents' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAgentEmailAndPhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mobileNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'mobileNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updateAllAgents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'updateAllAgents' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updateIntercomEmail' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intercomEmail' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAgentEmailAndPhoneMutation,
  SetAgentEmailAndPhoneMutationVariables
>;
export const AllAgentEmailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAgentEmails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllAgentEmailsQuery, AllAgentEmailsQueryVariables>;
export const SetUserAvatarDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetUserAvatar' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'avatar' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AvatarId' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setUserAvatar' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'avatar' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'avatar' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserAvatarMutation,
  SetUserAvatarMutationVariables
>;
